import React from "react";
import { useSelector } from "react-redux";
import { history } from "redux/configureStore";
import { _t } from "app/i18n/i18n";
import { isExcluded } from "./PillsBar";
import { FaIcon } from "lib/FaIcon";
import { getPathname, isPage } from "lib/routing";
import { Button } from "react-bootstrap";
import { gotoSearchPage } from "../api/filterUrlMaker";

export const AddFilterButton = ({ className }) => {
  const isVisible = getPathname() !== "/Search" && getPathname() !== "/Alt_Search_Results";
  const label = (
    <>
      <Plus /> {_t("Add Filter")}
    </>
  );
  return <FilterButton label={label} isVisible={isVisible} onClick={gotoSearchPage} className={className} />;
};

export const ClearAllPillsButton = () => {
  const filter = useSelector((state) => state.filter);
  const goClearAllTags = () => history.push(filter.path);
  const isVisible = Object.keys(filter.qsFilter).filter((key) => !isExcluded(key)).length;
  const label = (
    <>
      <X /> {_t("Clear All")}
    </>
  );
  return <FilterButton label={label} isVisible={isVisible} onClick={goClearAllTags} />;
};

export const MyFiltersButton = () => {
  const isVisible = isPage("/My_Research");
  const label = (
    <>
      <Gears /> {_t("My Filters")}
    </>
  );
  return <FilterButton label={label} isVisible={isVisible} onClick={() => history.push("/Preferences")} />;
};

const FilterButton = ({ label, onClick, isVisible, className }) => (
  <Button
    className={className}
    variant={
      "outline-secondary border shadow-sm btn-sm p-2 mb-1 mx-1 badge font-weight-normal " + (!isVisible && " d-none")
    }
    style={{ borderRadius: "7px" }}
    onClick={onClick}
  >
    {label}
  </Button>
);

const Plus = () => <FaIcon icon="fas fa-plus text-info" align="" />;
const X = () => <FaIcon icon="fas fa-times-circle text-primary fa-lg" align="" />;
const Gears = () => <FaIcon icon="fas fa-cogs text-success mr-1" align="" />;
